module.exports = __webpack_public_path__ + "static/media/360_hotspot.92809ca9.png";